export const T = {
  en_GB: {
    cancel: "Cancel",
    sellHoldingTitle: "Sell holding",
    sellHoldingDescription: (name: string, amount: string) =>
      `${name} — the client holds ${amount}. Enter how much to sell on completion; the rest stays in the account.`,
    sellAmountLabel: "Sell amount",
    sellAmountPlaceholder: "Leave empty to keep",
    sellAmountInvalid: (amount: string) => `Enter an amount above 0 and at most ${amount}.`,
    keepHolding: "Keep instead",
    confirmSell: "Sell",
    sellAllShortcut: "Sell all",
  },
  nb_NO: {
    cancel: "Avbryt",
    sellHoldingTitle: "Selg beholdning",
    sellHoldingDescription: (name: string, amount: string) =>
      `${name} — kunden har ${amount}. Angi hvor mye som skal selges ved fullføring; resten blir stående på kontoen.`,
    sellAmountLabel: "Salgsbeløp",
    sellAmountPlaceholder: "La stå tomt for å beholde",
    sellAmountInvalid: (amount: string) => `Angi et beløp over 0 og maks ${amount}.`,
    keepHolding: "Behold i stedet",
    confirmSell: "Selg",
    sellAllShortcut: "Selg alt",
  },
} as const;
